import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { map, Observable } from 'rxjs';

import { Store } from '@ngrx/store';
import { EntityTypesActions } from '../../../core/store/entity-types/entity-types.actions';
import { selectEntityType } from '../../../core/store/entity-types/entity-types.selectors';
import type { Entity, TreeEntity } from '../../../core/models/entity.model';
import type { EntityType } from '../../../core/models/entity-type.model';
import { FormGroup, UntypedFormGroup } from '@angular/forms';
import type { EntityEditorPropertyChangedEvent } from '../../models/entity-editor-property-changed.event';
import { MeasurementUnitsActions } from '../../../core/store/measurement-units/measurement-units.actions';
import { PropertyGroupType } from 'src/app/core/models/property-group-type.model';

@Component({
  selector: 'app-entity-editor',
  templateUrl: './entity-editor.component.html',
  styleUrls: ['./entity-editor.component.scss'],
  standalone: false
})
export class EntityEditorComponent implements OnInit, OnChanges {
  @Input() entity: Entity | TreeEntity;
  @Input() entityForm: UntypedFormGroup;
  @Input() groupFilter: (group: PropertyGroupType) => boolean;
  protected filteredGroups$: Observable<PropertyGroupType[]>;

  @Output() propertyChange: EventEmitter<EntityEditorPropertyChangedEvent> = new EventEmitter<EntityEditorPropertyChangedEvent>();

  protected entityTypes$: Observable<EntityType>;
  protected entityFormGroup: FormGroup;

  constructor(private store: Store) {
    this.entityTypes$ = this.store.select(selectEntityType(null));
  }

  ngOnInit(): void {
    this.entityFormGroup = this.entityForm || new FormGroup<any>({});
    this.store.dispatch(EntityTypesActions.entity_types_required());
    this.store.dispatch(MeasurementUnitsActions.measurement_units_needed());
  }

  private setupEntityObservables(): void {
    this.entityTypes$ = this.store.select(selectEntityType(this.entity.EntityTypeKey));
    this.filteredGroups$ = this.entityTypes$.pipe(
      map(entityType => {
        if (!entityType) {
          return [];
        }
        if (this.groupFilter) {
          return entityType.Groups.filter(this.groupFilter);
        }
        return entityType.Groups;
      })
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['entity']?.currentValue?.EntityTypeKey !== changes['entity']?.previousValue?.EntityTypeKey) {
      this.setupEntityObservables();
    }
  }

  propertyChanged(event: EntityEditorPropertyChangedEvent): void {
    this.propertyChange.emit(event);
  }
}
